import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";

import Home from "./Screen/Home";
import Contact from "./Screen/Contact";
import ServicesScreen from "./Screen/ServicesScreen";
import Blog from "./Screen/Blog";
import ErrorPage from "./Screen/ErrorPage";
import AboutUs from "./Screen/About";
import Project from "./Screen/Projects";
import FUQ from "./Screen/FUQ";
import Game from "./Screen/GameScreen";
import Try from "./Screen/Try";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="*" element={<ErrorPage />} />
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/service" element={<ServicesScreen />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/project" element={<Project />} />
          <Route path="/faq" element={<FUQ />} />
          <Route path="/game" element={<Game />} />
          <Route path="/Try" element={<Try />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
